module.exports = __webpack_public_path__ + "static/photo8-56dc9d4dda0ebf2de8fef21f481f5c61.jpg";